import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

const getUsers = () => {
  return axios.get(API_URL + "admin/users", { headers: authHeader() });
};

const createUser = (userData: {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhone: string;
  preferredLanguage: string;
  enabled: boolean;
  roles: number[];
}) => {
  return axios.post(API_URL + "admin/user", userData, { headers: authHeader() });
};

const updateUser = (userId: number, userData: {
  username: string;
  password?: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhone: string;
  preferredLanguage: string;
  enabled: boolean;
}) => {
  return axios.patch(API_URL + `admin/users/${userId}`, userData, { headers: authHeader() });
};

const deleteUser = (userId: number) => {
  return axios.delete(API_URL + `admin/users/${userId}`, { headers: authHeader() });
};

const getRoles = () => {
  return axios.get(API_URL + "admin/roles", { headers: authHeader() });
};

const registerUser = (registrationData: {
  usersEntityId: number;
  token: string;
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  mobilePhone: string;
}) => {
  return axios.post(API_URL + "user/register", registrationData);
};

const getRegistrationDetails = (usersentityid: string, token: string) => {
  return axios.get(API_URL + `user/register/detail?usersentityid=${usersentityid}&token=${token}`);
};

const companyUserService = {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getRoles,
  registerUser,
  getRegistrationDetails,
};

export default companyUserService; 